"use client";
import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { usePricesSocket } from "../core/hooks/usePrice";
import CoinImg from "./common/CoinImg";
import { formatNumber, Text, useMainContext } from "../modules/Dashboard";

const CoinSwiper = () => {
    const { main: { lang } } = useMainContext()
    const { pricesList, loading } = usePricesSocket();

    const items = useMemo(
        () =>
            (pricesList || []).map((p) => ({
                id: p.coin,
                name: p.name,
                price: p.sell,
            })),
        [pricesList, loading]
    );

    const loopItems = [...items, ...items, ...items];

    // Skeleton placeholder for loading state
    const skeletons = Array.from({ length: 10 });

    return (
        <div className="relative w-full overflow-hidden py-2 select-none">
            {loading ? (
                <div className="flex gap-10 items-center whitespace-nowrap animate-pulse">
                    {skeletons.map((_, idx) => (
                        <div
                            key={idx}
                            className="mx-6 flex items-center gap-2 text-white font-medium text-sm"
                        >
                            <div className="w-5 h-5 bg-gray-700 rounded-full" />
                            <div className="h-3 w-16 bg-gray-700 rounded" />
                            <div className="h-3 w-10 bg-gray-700 rounded" />
                        </div>
                    ))}
                </div>
            ) : (
                <motion.div
                    className="flex gap-10 items-center whitespace-nowrap "
                    initial={{ x: 0 }}
                    animate={{ x: lang === 'fa' ? "50%" : "-50%" }}
                    transition={{
                        repeat: Infinity,
                        repeatType: "loop",
                        ease: "linear",
                        duration: 20,

                    }}
                >
                    {loopItems.map((item, idx) => (
                        <div
                            key={item.id + "-" + idx}
                            className="mx-6 text-white font-medium text-sm flex items-center gap-1"
                        >
                            <CoinImg id={item.id} className="rounded-full" />
                            <Text tid={`${item.name}:`} className="capitalize" />
                            <span>
                                {formatNumber(item.price, {
                                    point: 2,
                                    type: "usdt",
                                })}
                            </span>
                        </div>
                    ))}
                </motion.div>
            )}
        </div>
    );
};

export default CoinSwiper;
